import { createReducer, on } from '@ngrx/store';
import { UploadExternalData } from '../models';

import * as actions from './toolupload.actions';

import { tooluploadInitialState, TooluploadState } from './toolupload.state';

export const vnaReducer = createReducer(
    tooluploadInitialState,
    on(actions.seOpenTooluploadDialog, (state, { data }) => updateDialog(state, data))
);

function updateDialog(state: TooluploadState, data: UploadExternalData) {
    return {
        ...state,
        data: data,
    };
}
